import {
    TOGGLE_MENU,
    NEW_PANEL_VERSION_DETECTED,
    CHANGE_LANGUAGE
} from '../actions/types';
import i18next from 'i18next';

const INITIAL_STATE = {
    ready: false,
    menuOpen: false,
    newVersionToUpdate: null,
    language: i18next.language
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case TOGGLE_MENU:
            return { ...state, menuOpen: !state.menuOpen };
        case NEW_PANEL_VERSION_DETECTED:
            return { ...state, newVersionToUpdate: action.payload };
        case CHANGE_LANGUAGE:
            return { ...state, language: action.payload };
        default:
            return state;
    }
};
